import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#5174d5",
      main: "#0049a3",
      dark: "#002373",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#DBDBDB",
    },
  },
  typography: {
    fontFamily: "'Lato', sans-serif;",
    fontSize: 18,

    button: {
      textTransform: "none",
      fontWeight: "normal",
    },
    h2: {
      fontSize: 36,
      fontWeight: 900,
      color: "#333333",
    },
    subtitle1: {
      color: "#979797",
      fontWeight: 600,
    },
    subtitle2: {
      fontSize: 20,
      fontWeight: 600,
    },
    body2: {
      fontSize: 14,
      fontWeight: 400,
      color: "#333333",
    },
  },

  overrides: {
    MuiFormControlLabel: {
      label: {
        color: "#333333",
        fontWeight: 700,
        fontSize:18
      },
    },
    MuiFormHelperText: {
      root: {
        "& .Mui-error": {
          margin: 0,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
          borderRadius: 6,
          border: 'none',
      },
      notchedOutline: {
          border: 'none'
      }
  },
  MuiTableCell:{
    root:{
      borderBottom:"1px solid #9797974C"
    },
    head:{
      borderBottom:"1px solid #979797"
    }
  },
  },
});

export default theme;
